// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reqwithdrawbutton{
    font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 700 !important;
line-height: 19.36px !important;
letter-spacing: 0.02em !important;
text-align: left !important;
color:#FFFFFF !important;


}
.reqwithdrawbuttoncont{
    /* width: 207px;
    height: 40px; */
    /* padding: 10px 20px 10px 20px; */
    gap: 10px;
    border-radius: 3px 0px 0px 0px;
    /* opacity: 0px; */
    background-color: #FE602F !important;
    /* text-align: left; */
    text-transform: capitalize !important;
    border:none;
    border-radius: 5px !important;
    color: white !important;
    white-space: nowrap !important;
overflow: hidden !important;
text-overflow: ellipsis !important;
text-transform: none !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19.36px !important;
letter-spacing: 0.02em !important;
text-align: left !important;
color:#FFFFFF !important;
height: 40px !important;
width: 100% !important


    
}
.leaveapplyfirstdivleave{
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    
    text-align: left;
    align-items: center;
    color: #0070E9;
    white-space: nowrap !important;
   
    text-overflow: ellipsis !important;
    text-transform: none !important;

}

.rlreqlevreqButton1{
 
    width:100% !important;
    max-width: 155px !important;
height:25px !important;
padding: 10px 20px 10px 20px !important;
gap: 10px !important;
border-radius: 3px 0px 0px 0px !important;

background-color: #FE602F !important;
color: white !important;
text-transform: none !important;
font-size: 15px !important;
font-weight: 600 !important;
white-space: nowrap !important;





}
`, "",{"version":3,"sources":["webpack://./src/views/panel/LeaveManagement/LeaveHistory/LeaveHistory.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC,0BAA0B;AAC1B,2BAA2B;AAC3B,+BAA+B;AAC/B,iCAAiC;AACjC,2BAA2B;AAC3B,wBAAwB;;;AAGxB;AACA;IACI;mBACe;IACf,kCAAkC;IAClC,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;IAClB,oCAAoC;IACpC,sBAAsB;IACtB,qCAAqC;IACrC,WAAW;IACX,6BAA6B;IAC7B,uBAAuB;IACvB,8BAA8B;AAClC,2BAA2B;AAC3B,kCAAkC;AAClC,+BAA+B;AAC/B,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,+BAA+B;AAC/B,iCAAiC;AACjC,2BAA2B;AAC3B,wBAAwB;AACxB,uBAAuB;AACvB;;;;AAIA;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;;IAEhB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,8BAA8B;;IAE9B,kCAAkC;IAClC,+BAA+B;;AAEnC;;AAEA;;IAEI,qBAAqB;IACrB,2BAA2B;AAC/B,sBAAsB;AACtB,uCAAuC;AACvC,oBAAoB;AACpB,yCAAyC;;AAEzC,oCAAoC;AACpC,uBAAuB;AACvB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,8BAA8B;;;;;;AAM9B","sourcesContent":[".reqwithdrawbutton{\r\n    font-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 700 !important;\r\nline-height: 19.36px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: left !important;\r\ncolor:#FFFFFF !important;\r\n\r\n\r\n}\r\n.reqwithdrawbuttoncont{\r\n    /* width: 207px;\r\n    height: 40px; */\r\n    /* padding: 10px 20px 10px 20px; */\r\n    gap: 10px;\r\n    border-radius: 3px 0px 0px 0px;\r\n    /* opacity: 0px; */\r\n    background-color: #FE602F !important;\r\n    /* text-align: left; */\r\n    text-transform: capitalize !important;\r\n    border:none;\r\n    border-radius: 5px !important;\r\n    color: white !important;\r\n    white-space: nowrap !important;\r\noverflow: hidden !important;\r\ntext-overflow: ellipsis !important;\r\ntext-transform: none !important;\r\nfont-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 600 !important;\r\nline-height: 19.36px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: left !important;\r\ncolor:#FFFFFF !important;\r\nheight: 40px !important;\r\nwidth: 100% !important\r\n\r\n\r\n    \r\n}\r\n.leaveapplyfirstdivleave{\r\n    font-family: \"Inter\";\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    \r\n    text-align: left;\r\n    align-items: center;\r\n    color: #0070E9;\r\n    white-space: nowrap !important;\r\n   \r\n    text-overflow: ellipsis !important;\r\n    text-transform: none !important;\r\n\r\n}\r\n\r\n.rlreqlevreqButton1{\r\n \r\n    width:100% !important;\r\n    max-width: 155px !important;\r\nheight:25px !important;\r\npadding: 10px 20px 10px 20px !important;\r\ngap: 10px !important;\r\nborder-radius: 3px 0px 0px 0px !important;\r\n\r\nbackground-color: #FE602F !important;\r\ncolor: white !important;\r\ntext-transform: none !important;\r\nfont-size: 15px !important;\r\nfont-weight: 600 !important;\r\nwhite-space: nowrap !important;\r\n\r\n\r\n\r\n\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
